import {Component, OnInit} from '@angular/core';
import {MatButton} from "@angular/material/button";
import {MatCard, MatCardContent, MatCardHeader, MatCardTitle} from "@angular/material/card";
import {MatIcon} from "@angular/material/icon";
import {ApiService} from "../api.service";
import {ActivatedRoute, Router} from "@angular/router";

@Component({
  selector: 'app-error',
    imports: [
        MatButton,
        MatCard,
        MatCardContent,
        MatCardHeader,
        MatCardTitle,
        MatIcon,
    ],
  templateUrl: './error.component.html',
  styleUrl: './error.component.css'
})
export class ErrorComponent implements OnInit {
  public message: string = '';

  constructor(public api: ApiService, public router: Router, private route: ActivatedRoute) {
  }

  ngAfterContentInit() {
    (document.querySelector('body') as HTMLElement).style.backgroundImage = 'linear-gradient(35deg, #fe3620 0%, #ff7c00 30%, #ff7c00 70%, #fe3620 90%)';
  }
  ngOnDestroy() {
    (document.querySelector('body') as HTMLElement).style.backgroundImage = 'unset';
  }

  ngOnInit() {
    this.route.data.subscribe(
      data => {
        this.message = data['message'];
      }
    );
  }

  goHome() {
    if (this.api.isLogged) {
      this.router.navigate(['dashboard']);
    }
    else {
      this.router.navigate(['login']);
    }
  }

}
